import { ActionTypes, ReduxAction } from './types';
import { Dispatch } from 'redux';

export const setLoading =
  (isLoading: boolean) => async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: isLoading,
    });
  };
